import { getDirect, apiGet } from 'services/api';
import { fetchAccessibleSchemas } from 'services/schemas';
import { toStartCase } from 'util/string';
import { deeplinkToURL } from 'services/deeplink';
import { memStore } from './storage';
import { chatStatus } from './chat';
export async function fetchChartData(url) {
  const data = await (/(^https?:\/\/)|(^\/static\/)/.test(url)
    ? getDirect(url)
    : apiGet(url));
  return (data && data.results) || data;
}
export async function fetchDynamicJSON(deeplink, query) {
  if (/^\/static\//.test(deeplink)) {
    const data = await getDirect(deeplink.replace(/^\/static/, ''));
    return data;
  }
  return apiGet(deeplink, { query });
}
const defaultMenus = [
  // TODO: replace static demo URLs
  // { title: "Dashboard", href: "/page/v2/dashboard?charts=true" },
  { title: 'Dashboard', href: '/reset/page/static/tmp/dashboard.json' },
  // { title: "Dashboard", href: "/details/v2/dashboard?charts=true" },
  { title: 'Chat', href: '/chat' },
  { title: 'Workorder', href: '/reset/list/static/tmp/workorder.json' },
  {
    title: 'Internal Dashboard',
    href: '/reset/list/static/tmp/locations.json',
  },
];
const clientMenu = [
  {
    title: 'Dashboard',
    href: '/page/static/tmp/dashboard.json',
    iconId: { selected: 110, notSelected: 9 },
  },
  {
    title: 'Content',
    href: '/page/static/tmp/content.json',
    iconId: { selected: 147, notSelected: 146 },
  },
];
async function fetchSchemaMenu() {
  const schemas = (await fetchAccessibleSchemas())
    .map(({ schema }) => schema)
    .sort((a, b) => +(b.menuOrder || 0) - (a.menuOrder || 0));
  return schemas.map((schema) => ({
    title: toStartCase(schema.title || schema.name),
    href: `/table/${schema.id}`,
    icon: schema.icon,
  }));
}
async function fetchDynamicMenu() {
  let entities = memStore.get('menuEntities');
  if (!entities) {
    const data = await apiGet(`/v2/entities`);
    entities =
      data.sections &&
      data.sections[0] &&
      data.sections[0].cards &&
      data.sections[0].cards[0] &&
      data.sections[0].cards[0].content;
    memStore.set('menuEntities', entities);
  }
  return entities.map((entity) => ({
    title: entity.title,
    href: deeplinkToURL(entity.deep_link, '/reset/list'),
    iconId: entity.iconId,
  }));
}
export function setMainMenuMode(menuMode) {
  memStore.set('menuMode', menuMode);
}
export async function fetchMainMenu() {
  const menuMode = memStore.get('menuMode');
  const chat = await chatStatus();
  if (menuMode === 'v1') {
    return v1MainMenu();
  }
  if (menuMode === 'advanced') {
    return advancedMenu();
  }
  if (localStorage.getItem('client')) {
    return [{ items: clientMenu }];
  }
  return [
    {
      items: await fetchDynamicMenu(),
    },
    {
      items: chat && [
        { title: 'Chat', href: '/chat', counter: chat.unreadRooms },
      ],
    },
  ];
}

export const fetchClientMenu = async () => {
  // const { data } = await getDirect(`/tmp/sidebar.json`);
  const { data } = await apiGet(`/side-bar`);

  const logo = data.sections[0].content.logo;
  const title = data.sections[0].content.title;
  const shortcuts = data.sections[0].content.shortcuts;
  const entities = data.sections[0].cards[0].content;

  memStore.set('menuEntities', entities);
  return [
    {
      items: entities.map((entity) => ({
        title: entity.title,
        subtitle:entity.subtitle,
        href: deeplinkToURL(entity.deep_link, '/reset/page'),
        iconId: entity.iconId,
        id: entity.id,
        children:
          entity.children &&
          entity.children.map((child) => ({
            title: child.title,
            id: child.id,
            href: deeplinkToURL(child.deep_link, '/reset/page'),
            iconId: child.iconId,
          })),
      })),
      logo,
      title,
      shortcuts,
    },
  ];
};

async function advancedMenu() {
  return [
    {
      items: await fetchDynamicMenu(),
    },
    {
      collapse: true,
      title: 'Advanced',
      items: await fetchSchemaMenu(),
    },
    {
      collapse: true,
      title: 'Test',
      items: defaultMenus,
    },
  ];
}
async function v1MainMenu() {
  return [
    {
      items: await fetchSchemaMenu(),
    },
  ];
}
